import ErrorModal from "@/components/modal/error-modal/error-modal";

const CorruptModelModal = () => {
  return ErrorModal({
    title: "Invalid voice model(s)",
    message:
      "An error occurred while applying the selected voice model(s). We're working to resolve the issue as quickly as possible. In the meantime, you can try using another voice models.",
  });
};

export default CorruptModelModal;
